import React from "react";
import BallotIcon from "@material-ui/icons/Ballot";

function PotvrdaRezervacijeIcon(props) {
  return <BallotIcon {...props}/>;
}

export default PotvrdaRezervacijeIcon;
